export var IconConstants = {
  ARROW: "fa-kit fa-arrow",
  ARROW_CIRCLE_DOWN: "fa-kit fa-arrowcircledown",
  ARROW_DOWN: "fa-light fa-arrow-down",
  ARROW_LEFT: "fa-light fa-arrow-left",
  ARROW_RIGHT: "fa-light fa-arrow-right",
  ARROW_UP: "fa-light fa-arrow-up",
  ARROWS_IN_SIMPLE: "fa-kit fa-arrowsinsimple",
  ARROWS_OUT_SIMPLE: "fa-kit fa-arrowsoutsimple",
  CALENDAR: "fa-kit fa-calendar",
  CHECK: "fa-kit fa-check",
  CHECKS: "fa-kit fa-checks",
  CHEVRON_DOWN: "fa-light fa-chevron-down",
  CHEVRON_LEFT: "fa-light fa-chevron-left",
  CHEVRON_RIGHT: "fa-light fa-chevron-right",
  CHEVRON_UP: "fa-light fa-chevron-up",
  CIRCLE_CHECK: "fa-solid fa-circle-check",
  CIRCLE_THREE_PLUS: "fa-kit fa-circlesthreeplus",
  CHAT_CIRCLE: "fa-kit fa-chatcircle",
  DOTS_SIX: "far fa-grip-dots-vertical",
  EDIT: "far fa-edit",
  ENVELOPE: "fa-kit fa-envelope",
  ELLIPSIS: "fa-light fa-ellipsis",
  EYE: "fa-kit fa-eye",
  EYE_SLASH: "fa-light fa-eye-slash",
  FLOOR_PLAN: "fa-kit fa-floorplan",
  FILE: "fa-kit fa-file",
  FILE_TEXT: "fa-kit fa-filetext",
  FILE_ARROW_DOWN: "fa-kit fa-filearrowdown",
  FILE_ARROW_UP: "fa-kit fa-filearrowup",
  FILTER: "fal fa-sliders-simple",
  FOLDER_OPEN: "fa-kit fa-folderopen",
  GEAR: "fa-kit fa-gear",
  IMAGE: "fa-kit fa-image",
  INFO_CIRCLE: "fa-light fa-circle-info",
  LIGHTNING: "fa-light fa-bolt",
  LINK: "fa-kit fa-link",
  MAP_PIN: "fa-kit fa-mappin",
  LOCATION_DOT: "fa-light fa-location-dot",
  MINUS: "fa-light fa-minus",
  PENCIL: "fa-kit fa-pencil",
  PDF: "fa-kit fa-pdf",
  PLAY: "fal fa-play",
  PLUS: "fa-kit fa-plus",
  SHARE: "fa-kit fa-share",
  SIGNIN: "fa-kit fa-signin",
  THUMBS_DOWN: "fa-kit fa-thumbsdown",
  THUMBS_DOWN_OLD: "fa-light fa-thumbs-down",
  THUMBS_DOWN_ACTIVE_OLD: "fa-solid fa-thumbs-down",
  THUMBS_UP: "fa-kit fa-thumbsup",
  THUMBS_UP_OLD: "fa-light fa-thumbs-up",
  THUMBS_UP_ACTIVE_OLD: "fa-solid fa-thumbs-up",
  TRASH: "fa-kit fa-trash",
  UPLOAD_SIMPLE: "fa-light fa-arrow-up-from-bracket",
  UPLOAD: "fa-kit fa-upload",
  X: "fal fa-xmark",
  BUILDINGS_TWO: "fa-kit fa-buildings-two",
  PAPER_PLANE_RIGHT: "fa-kit fa-paperplaneright",
  USER: "fa-kit fa-user",
  PHOTO: "far fa-camera",
  SORT_UP: "fa-kit fa-sortascending",
  SORT_DOWN: "fa-kit fa-sortdescending",
  EXCLAMATION_TRIANGLE: "fa-light fa-exclamation-triangle",
  SPINNER: "fa fa-pulse fa-spinner"
};